import { jsx as f } from "react/jsx-runtime";
import { QUERIES as N } from "@fcamna/shared-component-foundations";
import a, { useRef as U, useState as g } from "react";
import _ from "styled-components";
import { u as q } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u as v, C as d } from "./useChartOptions-336145ca.mjs";
const G = ({
  chartLibElement: x,
  legend: n,
  isCategorical: C = !0,
  colorPallete: y = ["blue"],
  hideLabel: S = !1,
  labelFormatter: $,
  series: i,
  labels: H,
  dataLabels: p,
  hideTooltip: b,
  height: c,
  width: h,
  legendClick: l
}) => {
  const W = q({ label: "Donut Chart" }), [m, T] = a.useState(!1), o = U(null), [j, D] = g(!1), [L, O] = g(200);
  a.useEffect(() => {
    T(!m);
  }, [p, n == null ? void 0 : n.totalText]), a.useEffect(() => {
    var s, u;
    const t = (s = o == null ? void 0 : o.current) == null ? void 0 : s.offsetHeight;
    t && O(t * 0.4);
    const e = (u = o == null ? void 0 : o.current) == null ? void 0 : u.querySelector(".apexcharts-legend");
    (e == null ? void 0 : e.scrollHeight) > (e == null ? void 0 : e.offsetHeight) && D(!0);
  }, [i]);
  const { options: r, customStyles: P } = v({
    legend: n,
    isCategorical: C,
    colorPallete: y,
    hideLabel: S,
    labelFormatter: $,
    type: d.DONUT,
    series: i,
    labels: H,
    dataLabels: p,
    hideTooltip: b
  });
  r.tooltip = {
    ...r.tooltip,
    fillSeriesColor: !1,
    borderRadius: 5,
    theme: !1
  }, r.chart = {
    ...r.chart,
    events: {
      legendClick: function(t, e, s) {
        l && l(e);
      }
    }
  };
  const R = i, { legendStyles: k, tooltipStyles: E } = P({
    type: d.DONUT
  }), M = _.div`
    ${E};
    ${k()};
    .apexcharts-tooltip {
      background: ${(t) => t.theme.components.donutChart.Wrapper.apexchartsTooltip.background};
    }
    min-height: ${(t) => t.theme.components.donutChart.Wrapper.minHeight};

    .apx-legend-position-right,
    .apx-legend-position-left {
      justify-content: ${({ $legendScroll: t, ...e }) => t ? `${e.theme.components.donutChart.Wrapper.apxLegendPositionLeftRight.justifyContent.legendScroll} !important` : `${e.theme.components.donutChart.Wrapper.apxLegendPositionLeftRight.justifyContent.default} !important`};
    }
    @media ${N.mobile} {
      min-height: ${(t) => t.theme.components.donutChart.Wrapper.mobile.minHeight};
      .apexcharts-legend {
        max-height: ${({ $legendMaxHeight: t, ...e }) => t || e.theme.components.donutChart.Wrapper.mobile.apexchartsLegend.maxHeight}px !important;
      }
    }
  `;
  return /* @__PURE__ */ f(
    M,
    {
      className: "donut-chart",
      "data-testid": "donut-chart-wrapper",
      ref: o,
      $legendScroll: j,
      $legendMaxHeight: L,
      ...W,
      children: /* @__PURE__ */ f(
        x,
        {
          width: h ? `${h}px` : "100%",
          height: c ? `${c}px` : "100%",
          options: r,
          series: R,
          type: "donut"
        },
        m ? 0 : 1
      )
    }
  );
};
export {
  G as DonutChart
};
